// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"1facbf91","199":"463355a5","214":"89af3209","538":"b60c5ae2","558":"208ad3a1","671":"a3bd01c1","964":"2d5a30cb"}[chunkId] + ".chunk.js";
};